import React from 'react'
import {Link} from 'react-router-dom'

const FooterSocials = () => {
  const awards = [
    {id: 'footer-facebook', uri: 'https://www.facebook.com/monefit', img: 'cs-social-fb.svg', alt: 'Creditstar Facebook'},
    {id: 'footer-instagram', uri: 'https://www.instagram.com/creditstargroup/', img: 'cs-social-instagram.svg', alt: 'Creditstar Instagram'},
    {id: 'footer-linkedin', uri: 'https://www.linkedin.com/company/creditstar-group-as/', img: 'cs-social-linkedin.svg', alt: 'Creditstar LinkedIn'}
  ]

  return (
    <div className="footer-socials-wrapper">
      {awards.map(({id, uri, img, alt}) =>
        <Link key={id} to={uri} target={'_blank'}>
          <img src={`../images/footer/social/${img}`} alt={alt} />
        </Link>
      )}
    </div>
  )
}

export default FooterSocials
